import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BsPersonCircle } from 'react-icons/bs';
import { MdAddAPhoto } from 'react-icons/md';
import CountryCodes from 'assets/json/countries.json';
import Button from 'components/Button';
import Dropdown from 'components/Dropdown2';
import DropdownSelect from 'components/DropdownSelect';
import TextInput from 'components/TextInput2';
import axios from 'config/axios';
import { auth, signOut } from 'config/firebase';
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { signIn } from 'store/user';
import { resetCart } from 'store/cart';
import { setAlert, setError } from 'store/error';
import './index.css';

const TARGETEXAM = {
    'ACT': 'Digital ACT',
    'SAT': 'Digital SAT',
    'PSAT': 'Digital PSAT'
};
const ACCOMODATIONS = {
    'None': 1,
    '50% Extra': 1.5,
    '100% Extra': 2
};

function PersonalInfo() {
    const { user } = useAppSelector(state => state.user);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const [profilePhoto, setProfilePhoto] = useState(user.profilePhoto);
    const [firstName, setFirstName] = useState(user.firstName);
    const [lastName, setLastName] = useState(user.lastName);
    const [email, setEmail] = useState(user.email);
    const [country, setCountry] = useState(user.countryCode
        ?   <div className='personalInfo__country' id={CountryCodes.find(country => country.isoCode === user.countryCode).isoCode}>
                <img src={CountryCodes.find(country => country.isoCode === user.countryCode).flag} />
                &nbsp;&nbsp;
                <p>{CountryCodes.find(country => country.isoCode === user.countryCode).dialCode}</p>
                {/* &nbsp;&nbsp;
                <p>{CountryCodes.find(country => country.dialCode === user.countryCode).name}</p> */}
            </div>
        :   <div className='personalInfo__country'></div>
    );
    const [countryCode, setCountryCode] = useState(user.countryCode);
    const [phoneNumber, setPhoneNumber] = useState(user.phoneNumber);
    const [birthDate, setBirthDate] = useState(user.birthDate ? user.birthDate.toString() : null);
    const [gender, setGender] = useState(user.gender);
    const [highSchool, setHighSchool] = useState(user.highSchool);
    const [classOf, setClassOf] = useState(user.classOf);
    const [postalCode, setPostalCode] = useState(user.postalCode);
    const [accomodation, setAccomodation] = useState(user.accomodation);
    const [targetExams, setTargetExams] = useState(user.targetExams);
    const [update, setUpdate] = useState(false);
    
    const handleTargetExam = (value) => {
        setTargetExams(prevData=> {
            if (prevData.includes(value)) {
                return prevData.filter(item=> item!==value);
            } else{
                return [...prevData, value];
            }
        });
    }

    const resetProfile = () => {
        setEmail(user.email);
        setFirstName(user.firstName);
        setLastName(user.lastName);
        setCountry(user.countryCode
            ?   <div className='personalInfo__country' id={CountryCodes.find(country => country.isoCode === user.countryCode).isoCode}>
                    <img src={CountryCodes.find(country => country.isoCode === user.countryCode).flag} />
                    &nbsp;&nbsp;
                    <p>{CountryCodes.find(country => country.isoCode === user.countryCode).dialCode}</p>
                    {/* &nbsp;&nbsp;
                    <p>{CountryCodes.find(country => country.dialCode === user.countryCode).name}</p> */}
                </div>
            :   <div className='personalInfo__country'></div>
        );
        setCountryCode(user.countryCode);
        setPhoneNumber(user.phoneNumber);
        setBirthDate(user.birthDate ? user.birthDate.toString() : null);
        setGender(user.gender);
        setHighSchool(user.highSchool);
        setClassOf(user.classOf);
        setPostalCode(user.postalCode);
        setAccomodation(user.accomodation);
        setTargetExams(user.targetExams);
    }

    const updateProfile = () => {
        axios.post('students/update/', {
                firstName: firstName,
                lastName: lastName,
                countryCode: countryCode,
                phoneNumber: phoneNumber,
                gender: gender,
                birthDate: birthDate,
                highSchool: highSchool,
                classOf: classOf,
                postalCode: postalCode,
                accomodation: accomodation,
                targetExams: targetExams
            })
            .then(res => {
                // console.log(res.data);
                dispatch(signIn(res.data?.user));
                setUpdate(false);
            })
            .catch(error => {
                // console.log(error);
                dispatch(setAlert(error));
                resetProfile();
                setUpdate(false);
            });
    }

    const updateProfilePhoto = (event: React.ChangeEvent<HTMLInputElement>) => {
        let formData = new FormData();
        formData.append('profilePhoto', Array.from(event.target.files)[0]);
        
        axios.post('students/profilePhoto/', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(res => {
                // console.log(res.data);
                setProfilePhoto(res.data.profilePhoto);
                dispatch(signIn({
                    ...user,
                    profilePhoto: res.data.profilePhoto
                }));
            })
            .catch(error => {
                // console.log(error);
                dispatch(setAlert(error));
            });
    }

    const handleSignOut = () => {
        signOut(auth)
            .then(() => {
                // console.log('Signed out!');
                dispatch(resetCart());
                navigate('/');
            })
            .catch(error => {
                // console.log(error);
                dispatch(setError(error));
            });
    }

    return (
        <div className='personalInfo'>
            <div className='personalInfo__column'>
                <div className='personalInfo__form'>
                    <label className='personalInfo__photo' htmlFor='profilePhoto'>
                        <input
                            id='profilePhoto'
                            accept='image/*'
                            type='file'
                            onChange={updateProfilePhoto}
                        />
                        {profilePhoto
                            ? <img className='personalInfo__photoImage' src={profilePhoto} />
                            : <BsPersonCircle className='personalInfo__photoImage' />
                        }
                        <p className='personalInfo__photoAdd'>
                            <MdAddAPhoto />
                            {profilePhoto
                                ? 'UPDATE PHOTO'
                                : 'ADD PHOTO'
                            }
                        </p>
                    </label>
                    
                    <div className='personalInfo__grid'>
                        <TextInput
                            className='personalInfo__inputFull'
                            name='email'
                            label='Email'
                            onChange={(event) => setEmail(event.target.value)}
                            type='text'
                            required
                            value={email}
                            disabled
                        />
                        <TextInput
                            name='firstName'
                            label='First name'
                            onChange={(event) => setFirstName(event.target.value)}
                            type='text'
                            required
                            value={firstName}
                            disabled={!update}
                        />
                        <TextInput
                            name='lastName'
                            label='Last name'
                            onChange={(event) => setLastName(event.target.value)}
                            type='text'
                            required
                            value={lastName}
                            disabled={!update}
                        />
                        {/* <DropdownSelect
                            label='Target Exam'
                            placeholder='Select all that apply'
                            data={Object.keys(TARGETEXAM)}
                            disabled={!update}
                            selected={Object.values(TARGETEXAM).map(exam => targetExams?.includes(exam))}
                            onSelect={value => handleTargetExam(TARGETEXAM[value])}
                        />
                        <Dropdown
                            data={Object.keys(ACCOMODATIONS)}
                            onSelect={(value) => setAccomodation(ACCOMODATIONS[value])}
                            label='Time Extension'
                            value={Object.keys(ACCOMODATIONS).find(key => ACCOMODATIONS[key] == accomodation)}
                            disabled={!update}
                        /> */}
                        <Dropdown
                            data={CountryCodes.map(country => (
                                <div className='personalInfo__country' id={country.isoCode}>
                                    <img src={country.flag} />
                                    &nbsp;&nbsp;
                                    <p>{country.dialCode}</p>
                                    {/* &nbsp;&nbsp;
                                    <p>{country.name}</p> */}
                                </div>
                            ))}
                            onSelect={(value) => {
                                setCountryCode(value.props.id);
                                setCountry(value);
                            }}
                            label='Country Code'
                            value={country}
                            disabled={!update}
                        />
                        <TextInput
                            name='phoneNumber'
                            label='Phone number'
                            onChange={(event) => {
                                const value = event.target.value.replace(/[^\d]/g, '');
                                if (value.length <= 15) setPhoneNumber(value);
                            }}
                            type='text'
                            value={phoneNumber}
                            disabled={!update}
                        />
                        <TextInput
                            name='dateOfBirth'
                            label='Date of birth'
                            onChange={(event) => setBirthDate(event.target.value)}
                            type='date'
                            value={birthDate}
                            disabled={!update}
                        />
                        <Dropdown
                            data={['Male', 'Female', 'Prefer not to say']}
                            onSelect={(value) => setGender(value)}
                            label='Gender'
                            value={gender}
                            disabled={!update}
                        />
                        <TextInput
                            className='personalInfo__inputFull'
                            name='highSchool'
                            label='High school'
                            onChange={(event) => setHighSchool(event.target.value)}
                            type='text'
                            value={highSchool}
                            disabled={!update}
                        />
                        <Dropdown
                            data={[...Array(50)].map((_, i) => new Date().getFullYear() + 5 - i)}
                            onSelect={(value) => setClassOf(value)}
                            label='Class of'
                            value={classOf}
                            disabled={!update}
                        />
                        <TextInput
                            name='postalCode'
                            label='Zip code'
                            onChange={(event) => {
                                const value = event.target.value.replace(/[^\d]/g, '');
                                if (value.length <= 12) setPostalCode(value);
                            }}
                            type='text'
                            value={postalCode}
                            disabled={!update}
                        />
                    </div>
                    <Button
                        className='personalInfo__submit'
                        secondary={!update}
                        // disabled={
                        //     email === user.email &&
                        //     countryCode === user.countryCode &&
                        //     phoneNumber === user.phoneNumber &&
                        //     firstName === user.firstName &&
                        //     lastName === user.lastName &&
                        //     (user.birthDate ? birthDate === user.birthDate.toString() : !birthDate) &&
                        //     gender === user.gender &&
                        //     highSchool === user.highSchool &&
                        //     classOf === user.classOf &&
                        //     postalCode === user.postalCode &&
                        //     accomodation === user.accomodation
                        // }
                        onClick={update
                            ? updateProfile
                            : () => setUpdate(true)
                        }
                        type='submit'
                    >
                        {update ? 'SAVE' : 'UPDATE PROFILE'}
                    </Button>
                </div>
                <Button
                    className='personalInfo__signOut'
                    onClick={handleSignOut}
                >
                    SIGN OUT
                </Button>
            </div>
        </div>

    );
}

export default PersonalInfo;